export default "__VITE_ASSET__B4AQlh49__"